export default {
    bis: 'Biuletyn Informacyjny Studentów AGH',
    cm: 'Centrum Mediów AGH',
    ksaf: 'KSAF - Krakowska Studencka Agencja Fotograficzna',
    mine: 'MINE AGH - Filmowe studio produkcyjne AGH',
    radio17: 'Radio1.7 - Najlepsze studenckie radio w Krakowie!'
}
